var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlipbitText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1216 387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #0820c8;\n      }\n\n      .st1 {\n        isolation: isolate;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.4,103.3v86.9h114.4v20.2H59.4v93.8h-23.4V83.1h151.6v20.2H59.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236,83.1h23.4v200.9h123.8v20.2h-147.2V83.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422,83.1h23.4v221.1h-23.4V83.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M690.6,158.9c0,47.1-34.1,75.5-90.3,75.5h-59.4v69.8h-23.4V83.1h82.8c56.2,0,90.3,28.4,90.3,75.8ZM667.2,158.9c0-35.4-23.4-55.6-67.6-55.6h-58.8v110.6h58.8c44.2,0,67.6-20.2,67.6-55Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M771.8,190.2c-20.2-8.2-33.8-25-33.8-50.2,0-36,28.4-56.9,77.7-56.9h95.4v221.1h-101.7c-55.3,0-83.1-21.5-83.1-59.1,0-30,17.1-48.6,45.5-55ZM809.7,285h78s0-83.1,0-83.1h-78c-38.9,0-60,12.6-60,41.4,0,29.1,21.2,41.7,60,41.7ZM817.3,102.4c-35.4,0-55.9,13.6-55.9,40.1s20.5,40.1,55.9,40.1h70.4s0-80.2,0-80.2h-70.4Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M975.3,82.6h23.4v221.1h-23.4V82.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1113.6,102.9h-77.7v-20.2h178.8v20.2h-77.7v200.9h-23.4V102.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipbitText);
export default __webpack_public_path__ + "static/media/FlipbitText.4c0d79506ee16b1bd1e04a857deb1ef3.svg";
export { ForwardRef as ReactComponent };